import type * as React from "react";

import { cn } from "@/lib/utils";

// Also styles the headings that name a group of controls (a <legend>) or
// a form, which are not <label>s.
const labelClassName =
  "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled]:pointer-events-none group-data-[disabled]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-[[data-disabled]]:opacity-50";

// Base UI has no standalone Label primitive; a native <label> covers htmlFor
// association, and the disabled/peer styling lives in labelClassName.
function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: generic label; consumers associate a control via htmlFor or peer/wrapping
    <label
      className={cn(labelClassName, className)}
      data-slot="label"
      {...props}
    />
  );
}

export { Label, labelClassName };
